import {
  AUDIT_POLICY,
  BLOCKING_POLICY,
  GLOBAL_POLICY_SLUG,
  GLOBAL_SECRETS_POLICY_SLUG,
  PR_COMMENTS_POLICY,
  SECRETS_AUDIT_POLICY,
  SECRETS_BLOCKING_POLICY,
  SECRETS_PR_COMMENTS_POLICY,
} from "@shared/constants";

const POLICY_MODES = {
  BLOCKING: BLOCKING_POLICY.slug,
  PR_COMMENTS: PR_COMMENTS_POLICY.slug,
  AUDIT: AUDIT_POLICY.slug,
  SECRETS_BLOCKING: SECRETS_BLOCKING_POLICY.slug,
  SECRETS_PR_COMMENTS: SECRETS_PR_COMMENTS_POLICY.slug,
  SECRETS_AUDIT: SECRETS_AUDIT_POLICY.slug,
};

/**
 * TODO(sal): Eventually we will want to phase out this endpoint. This work should really be done on the backend and returned
 * on this issue model.
 */
export const getRuleBoardSlugFromPolicySlug = (
  policySlug: string | undefined
): string => {
  if (!policySlug) return "unknown";

  const policyMode = getPolicyMode(policySlug);
  if (!policyMode) return "unknown";

  // Multiple rule board slugs are in the format of {rule-board-slug}-{policy-mode}
  // so we can split on policyMode to get the rule board slug
  const [ruleBoardSlug] = policySlug.split(policyMode);

  // If ruleBoardSlug is an empty string, then we know that the policySlug belongs to a Global Policy
  if (!ruleBoardSlug) {
    return policyMode.includes("secrets")
      ? GLOBAL_SECRETS_POLICY_SLUG
      : GLOBAL_POLICY_SLUG;
  }

  // Remove trailing hyphen from the rule board slug
  return ruleBoardSlug.slice(0, -1);
};

const getPolicyMode = (policySlug: string): string | undefined => {
  for (const mode of Object.values(POLICY_MODES)) {
    if (policySlug.includes(mode)) return mode;
  }
  return undefined;
};
